const AppConfig = {
    languages : [
        'en', 'de'
    ],
    defaultLanguage : 'en',
    backend_url : 'http://65.1.73.181:3003'
};

export {AppConfig};
